import React, { useEffect } from "react";

import { useForm } from "react-hook-form";

import { ITheme } from "../../models/theme/Theme";
import { ButtonInput } from "../Shared/Inputs/ButtonInput";
import Flyout, { FlyoutControlProps } from "../../containers/Flyout";
import { useThemeMutations } from "../../data/theme/useThemeMutations";
import { StyledTextInput } from "../Shared/StyledInputs/StyledTextInput";
import StyledSwitchInput from "../Shared/StyledInputs/StyledSwitchInput";

interface CreateUpdateThemeFlyoutProps extends FlyoutControlProps {
  theme?: ITheme;
}

export function CreateUpdateThemeFlyout({ open, setOpen, theme }: CreateUpdateThemeFlyoutProps) {
  const { create, update } = useThemeMutations();
  const isUpdate = theme !== undefined;

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset
  } = useForm<ITheme>({
    defaultValues: { name: "", active: false }
  });

  const onSubmit = (data: ITheme) => {
    if (isUpdate) {
      update.mutate(data, { onSuccess: () => setOpen(false) });
    } else {
      create.mutate(data, { onSuccess: () => setOpen(false) });
    }
  }

  useEffect(() => {
    if (theme) {
      reset(theme);
    } else {
      reset({ name: "", active: false });
    }
  }, [theme, reset]);

  return (
    <Flyout open={open} setOpen={setOpen} title={isUpdate ? "Update Theme" : "Create Theme"}>
      <div>
        <form onSubmit={handleSubmit(onSubmit)} className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <StyledTextInput
            label="Name"
            register={register}
            registerName="name"
            registerOptions={{ required: "Name is required" }}
          />
          <StyledSwitchInput
            label="Active"
            register={register}
            registerName="active"
            setValue={setValue}
            watch={watch}
            classes="flex items-end"
          />
          <div className="mt-6 sm:col-span-2">
            <ButtonInput
              isSubmit={true}
              label={isUpdate ? "Update Theme" : "Create Theme"}
              onClick={undefined}
              children={undefined}
              classes={undefined}
            />
          </div>
        </form>
      </div>
    </Flyout>
  )

}